<template>
  <div class="modal" :class="{ 'modal--Sub': isChild }" @click.self="close">
    <button @click="closeModal()" class="modal__Overlay"></button>
    <success-prompt :updated="updated" :message="prompt.success"></success-prompt>

    <div class="modal__Inner" :class="{ 'modal__Inner--Sub': isChild }">
      <section class="modal__Post">
        <error-prompt class="error--Modal" :errors="errors"></error-prompt>
        <loader class="imageLoader" :loading="loading || updating" />

        <header class="modal__Header">
          <h1 class="modal__Title">Edit website</h1>

          <div class="modal__Meta">
            <ul>
              <li class="modal__MetaItem--Button">
                <button @click="update()" :disabled="updated === true" class="button--Small">
                  {{ prompt.save }}
                </button>
              </li>
              <li class="modal__MetaItem">
                <button @click="closeModal()" class="modal__MetaLink">
                  <icon name="times"></icon>
                </button>
              </li>
            </ul>
          </div>
        </header>

        <template>
          <div class="formSection">
            <div class="formSection__Row">
              <p class="formSection__ApiKey" v-if="item.api_key">
                <label class="formLabel">API key</label>
                {{ item.api_key }}
              </p>
            </div>
            <div class="formSection__Row">
              <label class="formLabel" for="editPermissions">{{
                $store.getters.getStringTranslation('permissions')
              }}</label>
              <ul class="formCheckboxGroup">
                <li>
                  <input
                    class="formCheckbox__Checkbox"
                    type="checkbox"
                    v-model="item.permissions"
                    name="editPermission"
                    id="guest_can_post"
                    value="guest_can_post"
                  />
                  <label class="formCheckbox__Label" for="guest_can_post">{{
                    $store.getters.getStringTranslation('guestCanPost')
                  }}</label>
                </li>

                <li>
                  <input
                    class="formCheckbox__Checkbox"
                    type="checkbox"
                    v-model="item.permissions"
                    name="editPermission"
                    id="user_can_register"
                    value="user_can_register"
                  />
                  <label class="formCheckbox__Label" for="user_can_register">User can register</label>
                </li>

                <li>
                  <input
                    class="formCheckbox__Checkbox"
                    type="checkbox"
                    v-model="item.permissions"
                    name="editPermission"
                    id="user_can_register_org"
                    value="user_can_register_org"
                  />
                  <label class="formCheckbox__Label" for="user_can_register_org">User can register organisation</label>
                </li>
              </ul>
            </div>

            <ul class="formSection__Types" v-if="tabs.length > 0">
              <li class="formSection__TypesTab" v-for="tab in tabs" :key="tab.id">
                <input type="radio" name="type" v-model="currentTab" :id="`type-${tab.value}`" :value="tab.value" />
                <label :for="`type-${tab.value}`">
                  <icon :name="tab.icon"></icon>
                  {{ tab.label }}
                </label>
              </li>
            </ul>
            <div v-if="currentTab === 'general-website'">
              <div class="formSection__Row">
                <p>
                  <label class="formLabel" for="editURL">URL</label>
                  <input required v-model="item.url" type="text" class="formInput" id="editURL" />
                </p>
              </div>
              <div class="formSection__Row--Gray formSection__Row--Group">
                <div v-if="item.url === 'https://publicservices.international'">
                  <p>
                    <input
                      class="formCheckbox__Checkbox"
                      type="checkbox"
                      v-model="item.additionals.hasLiveBlog"
                      name="hasLiveBlog"
                      id="hasLiveBlog"
                    />
                    <label class="formCheckbox__Label" for="hasLiveBlog">Live blog alert</label>
                  </p>
                  <div v-if="item.additionals.hasLiveBlog">
                    <p>
                      <label class="formLabel">Choose the Live Blog language you want to update</label>
                      <select class="formSelect" v-model="liveBlogTab">
                        <option
                          v-for="(translation, index) in item.additionals.l10n"
                          :key="translation.id"
                          :value="index"
                        >
                          {{
                            languages.find((l) => l.value === index) && languages.find((l) => l.value === index).label
                          }}
                          {{ translation.liveBlogUrl && translation.liveBlogText ? ' + ' : '' }}
                        </option>
                      </select>
                    </p>

                    <div v-for="(translation, index) in item.additionals.l10n" :key="translation.id">
                      <template v-if="liveBlogTab === index">
                        <p>
                          <label class="formLabel">Live blog URL</label>
                          <input v-model="translation.liveBlogUrl" type="text" class="formInput" />
                        </p>
                        <p>
                          <label class="formLabel">Live blog text</label>
                          <input v-model="translation.liveBlogText" type="text" class="formInput" />
                        </p>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="formSection__Row">
                <h2 class="formTitle--with-Note">{{ $store.getters.getStringTranslation('internalLinks') }}</h2>
                <p class="note--with-Title">
                  {{ $store.getters.getStringTranslation('internaLinksDesc') }}
                </p>
                <div
                  class="formSection__Columns--Repeater"
                  v-for="(url, index) in item.additionals.website_urls"
                  :key="`website-url-${index}`"
                >
                  <p class="formSection__Column--Tight">
                    <label class="formLabel" :for="`website-url-name-${index}`">{{
                      $store.getters.getStringTranslation('nameInternal')
                    }}</label>
                    <select class="formSelect" required v-model="url.name" :id="`website-url-name-${index}`">
                      <option v-for="(type, index) in types" :value="type" :key="`website-url-name-type-${index}`">
                        {{ capitalize(type) }}
                      </option>
                      <option value="pptx" :key="`website-url-name-type-${types.length + 1}`">Pptx</option>
                      <option value="docx" :key="`website-url-name-type-${types.length + 2}`">Docx</option>
                    </select>
                  </p>
                  <p class="formSection__Column--Tight">
                    <label class="formLabel" :for="`website-url-link-${index}`">URL</label>
                    <input
                      required
                      v-model="url.link"
                      @blur="checkURL(url)"
                      type="text"
                      class="formInput"
                      :id="`website-url-link-${index}`"
                    />
                  </p>
                  <p class="formSection__Column--Tight formSection__Column--Button">
                    <button class="button--Scrape" @click="removeURL(index)">
                      <icon name="trash-alt"></icon>
                      <span>Remove</span>
                    </button>
                  </p>
                </div>
                <p class="note" v-if="item.additionals.website_urls.length === 0">
                  No URLs specified. To add post previews please specify URL endpoints.
                </p>
                <button class="button" @click="addURL">Add URL base</button>
              </div>
              <div class="formSection__Row--Group formSection__Row--Gray">
                <h2 class="formTitle--with-Note">Custom attributes</h2>
                <p class="note--with-Title">
                  A comma-separated list of custom attributes for developers to use within their website (e.g. page
                  templates for different page layouts)
                </p>

                <p>
                  <label class="formLabel" for="editPostFlags">Edit available post flags</label>

                  <input
                    :value="item.additionals.post_flags"
                    @input="setPostFlag"
                    type="text"
                    placeholder="show_menu, remove_author, etc."
                    class="formInput"
                    id="editPostFlags"
                  />
                </p>

                <p>
                  <label class="formLabel" for="editPageTemplates">Edit available page templates</label>

                  <input
                    :value="item.additionals.page_templates"
                    @input="setPageTemplate"
                    type="text"
                    placeholder="contact, home, about_us, etc."
                    class="formInput"
                    id="editPageTemplates"
                  />
                </p>
              </div>
              <div class="formSection__Row">
                <h2 class="formTitle--with-Note">Admin appearance</h2>
                <p class="note--with-Title">
                  Coose which fields, tags and other options to display on your website's admin interface.
                </p>
              </div>
              <div
                class="formSection__Row--Group"
                :class="{ 'formSection__Row--First': arrIndex === 0 }"
                v-for="(_, groupIndex, arrIndex) in item.additionals.defaults"
                :key="`defaults-group-${groupIndex}`"
              >
                <label class="formLabel">{{ capitalize(groupIndex) }}</label>
                <ul class="formCheckboxGroup">
                  <li v-for="(_, index) in item.additionals.defaults[groupIndex]" :key="`default-fields-${index}`">
                    <input
                      class="formCheckbox__Checkbox"
                      type="checkbox"
                      v-model="item.additionals.defaults[groupIndex][index]"
                      :id="`defaults-fields-${groupIndex}-${index}`"
                    />
                    <label class="formCheckbox__Label" :for="`defaults-fields-${groupIndex}-${index}`"
                      >{{ capitalize(index) }}
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="currentTab === 'blocks'">
              <vue-json-editor v-model="item.additionals.website_blocks" :show-btns="false"></vue-json-editor>
            </div>
            <div v-if="currentTab === 'translations'">
              <vue-json-editor v-model="item.translations" :show-btns="false"></vue-json-editor>
            </div>
            <div v-if="currentTab === 'navigations'">
              <vue-json-editor v-model="item.navigations" :show-btns="false"></vue-json-editor>
            </div>
          </div>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
import { languages, ISOlanguages } from '@/router/globals.js'
import HTTP from '@/http-common.js'
import vueJsonEditor from 'vue-json-editor'

import GetProperty from '@/components/mixins/GetProperty.js'
import Capitalize from '@/components/mixins/Capitalize.js'

import Loader from '@/components/partials/Loader.vue'
import ErrorPrompt from '@/components/editor/ErrorPrompt.vue'
import SuccessPrompt from '@/components/editor/SuccessPrompt.vue'

export default {
  name: 'EditWebsite',
  components: {
    vueJsonEditor,
    Loader,
    ErrorPrompt,
    SuccessPrompt,
  },
  props: ['queryParams'],
  mixins: [GetProperty, Capitalize],
  data() {
    return {
      item: {
        id: '',
        org_id: '',
        api_key: null,
        permissions: [],
        url: '',
        additionals: {
          website_blocks: [],
          website_urls: [],
          l10n: {},
          defaults: {
            blocks: {
              image_block: true,
              image_quote: true,
              video_block: true,
              resources_block: true,
              related_resources_block: true,
              attachments: true,
              petition_block: true,
              event_block: true,
              quiz_block: true,
            },
            general_options: {
              start_with_text: true,
              subtitle: true,
              foreword: true,
              parent: true,
              custom_fields: true,
            },
            resources: {
              submissions: true,
              pages: true,
              blog: true,
              campaigns: true,
              projects: true,
              events: true,
              tags: true,
              article: true,
              publications: true,
              digital_publication: true,
              clause: false,
              multimedia: true,
              quiz: true,
              case_studies: true,
              uploads: false,
            },
            tags: {
              issue: true,
              sector: true,
              organisation: true,
              country: true,
              region: true,
              type: true,
              clause_type: false,
              clause_theme: false,
            },
          },
        },
      },
      prompt: {
        save: 'Save',
        success: '',
      },
      tabs: [
        { value: 'general-website', icon: 'cog', label: 'General' },
        { value: 'blocks', icon: 'th-large', label: 'Website blocks' },
        { value: 'translations', icon: 'globe', label: 'Translations' },
        { value: 'navigations', icon: 'align-justify', label: 'Navigations' },
      ],
      currentTab: 'general-website',
      liveBlogTab: 'en',
      parent: null,
      loading: true,
      updating: false,
      updated: false,
      errors: '',
    }
  },
  computed: {
    languages() {
      return languages
    },
    ISOlanguages() {
      return ISOlanguages
    },
    lang() {
      return this.$store.state.ui.lang
    },
    types() {
      return this.$store.state.types.default
    },
    isChild() {
      return this.$route.path.includes('organisations')
    },
  },
  mounted() {
    // Get defaults before post has been fetched
    const defaults = JSON.parse(JSON.stringify(this.item.additionals.defaults))
    const getDefaultsLength = (obj) => {
      return [].concat.apply(
        [],
        Object.values(obj).map((item) => Object.keys(item))
      )
    }

    if (this.$route.params.website_id !== undefined) {
      this.item.api_key = 'Loading...'
      this.prompt.success = 'Success! Website has been updated.'
      this.prompt.save = 'Save'

      HTTP.get(`org/${this.$store.state.accounts.org.id}/websites/${this.$route.params.website_id}`)
        .then((response) => {
          this.item = response.data

          const additionals = {
            post_flags: '',
            page_templates: '',
            website_urls: [],
            defaults,
          }

          // Check whether field exists
          Object.keys(additionals).forEach((key) => {
            if (this.item.additionals[key] === undefined) this.$set(this.item.additionals, key, additionals[key])
          })

          // Pre-populate defaults
          Object.keys(defaults).forEach((type) => {
            this.item.additionals.defaults[type] = {
              ...defaults[type],
              ...this.item.additionals.defaults[type],
            }
          })

          let languages = {}
          this.ISOlanguages.forEach((lang) => {
            languages[lang.toLowerCase()] = {
              liveBlogText: '',
              liveBlogUrl: '',
            }
          })

          // Check whether post returns l10n. If not, make sure to create them
          languages = { ...languages, ...this.item.additionals.l10n }
          this.$set(this.item.additionals, 'l10n', languages)

          // Check if any or all of the default values are different. If yes, update object
          if (getDefaultsLength(this.item.additionals.defaults).length !== getDefaultsLength(defaults).length) {
            getDefaultsLength(defaults)
              .filter((x) => !getDefaultsLength(this.item.additionals.defaults).includes(x))
              .forEach((y) => {
                Object.keys(defaults).forEach((z) => {
                  if (defaults[z][y]) {
                    this.$set(this.item.additionals.defaults[z], [y], defaults[z][y])
                    return
                  }
                  return
                })
              })
          }

          this.loading = false

          this.prompt.save = 'Save'
          this.prompt.success = 'Success! Website updated.'
        })
        .catch((e) => {
          this.errors = e.response ? e.response.data : console.error(e)
          this.loading = false
        })
    } else {
      this.loading = false
      this.prompt.success = 'Success! Website created.'
      this.prompt.save = 'Create'
    }

    // Define parent URL
    let path = this.$route.matched[0].path
    if (this.isChild) path = this.$route.matched[1].path.replace(':id', this.$route.params.id)
    this.parent = {
      path,
      query: {
        search: JSON.stringify(this.queryParams),
      },
    }
  },
  methods: {
    closeModal() {
      if (this.changed === true) {
        if (confirm('Are you sure you wish to close the editor? Everything not saved will be lost!')) {
          this.$router.push(this.parent)
        }
      } else {
        this.$router.push(this.parent)
      }
    },
    update() {
      this.loading = true
      let url = `org/${this.$store.state.accounts.org.id}/websites`
      let method = 'post'

      if (this.$route.params.website_id !== undefined) {
        url = `org/${this.$store.state.accounts.org.id}/websites/${this.$route.params.website_id}`
        method = 'put'
      }

      HTTP.request({ method, url, data: { website: this.item } })
        .then((response) => {
          this.$store.dispatch('updateWebsite', { item: response.data })
          this.updated = true
          this.loading = false

          // Enable edit
          setTimeout(() => {
            this.updated = false
          }, 3000)
        })
        .catch((e) => {
          this.errors = e.response ? e.response.data : console.error(e)
          this.loading = false
        })
    },
    addURL() {
      this.item.additionals.website_urls.push({ name: this.types[0], link: '' })
    },
    removeURL(index) {
      this.item.additionals.website_urls.splice(index, 1)
    },
    checkURL(item) {
      const lastChar = item.link.length - 1
      if (item.link.charAt(lastChar) === '/' && item.link.charAt(0) === '/') {
        item.link = item.link.substring(1, lastChar)
      } else if (item.link.charAt(lastChar) === '/') {
        item.link = item.link.substring(0, lastChar)
      } else if (item.link.charAt(0) === '/') {
        item.link = item.link.substring(1, lastChar + 1)
      }
    },
    setPostFlag($e) {
      this.item.additionals.post_flags = $e.target.value.replace(' ', ',')
    },
    setPageTemplate($e) {
      this.item.additionals.page_templates = $e.target.value.replace(' ', ',')
    },
  },
}
</script>
